/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleDto } from '../../models/enrollment-schedule-dto';

export interface EnrollmentScheduleGroupControllerFindSchedulesByGroupId$Params {
  groupId: string;
}

export function enrollmentScheduleGroupControllerFindSchedulesByGroupId(http: HttpClient, rootUrl: string, params: EnrollmentScheduleGroupControllerFindSchedulesByGroupId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleGroupControllerFindSchedulesByGroupId.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnrollmentScheduleDto>>;
    })
  );
}

enrollmentScheduleGroupControllerFindSchedulesByGroupId.PATH = '/api/enrollment-schedule-group';
